import React, { ReactNode } from "react"

import { Grid, GridItem } from "components/Grid"
import { Flex, FlexItem } from "components/Flex"
import Text from "components/Text/Text"
import InfoButton from "components/InfoButton/InfoButton"
import Pictogram from "components/Pictogram/Pictogram"
import Badge from "components/Badge/Badge"

interface ISelectSearchOption {
    title: ReactNode
    badge?: string
    badges?: ReactNode
    subtitle: ReactNode
    pictogramUrl: string
    thumbnailUrl?: string,
    onShowDetailsClick(): void
}

const SelectSearchOption = ({
    pictogramUrl,
    thumbnailUrl,
    title,
    badge,
    badges,
    subtitle,
    onShowDetailsClick,
}: ISelectSearchOption) => (
    <Grid
        className="w-100"
        columns="6.4rem auto"
        gap="2.4rem">
        <GridItem alignSelf="center">
            <Pictogram
                src={thumbnailUrl || pictogramUrl}
                cover={!!thumbnailUrl} />
        </GridItem>
        <GridItem alignSelf="center">
            <Flex
                justifyContent="space-between"
                alignItems="center">
                <FlexItem>
                    <Text type="p">{title}</Text>
                </FlexItem>
                <FlexItem shrink={0} className="ml-2">
                    <Flex alignItems="center" gap="0.8rem">
                        {!!badge && <Badge>{badge}</Badge>}
                        {badges}
                        <InfoButton onClick={onShowDetailsClick} />
                    </Flex>
                </FlexItem>
            </Flex>
            <Text type="p" className="word-break-break-word">
                {subtitle}
            </Text>
        </GridItem>
    </Grid>
)

export default SelectSearchOption
